import PropTypes from 'prop-types';
import Icon from '../Icon';
import RawHtml from '../RawHtml/RawHtml';
import GlossaryText from '../GlossaryText';
import styles from './ManualChapterTitle.module.scss';

const ManualChapterTitle = ({ icon = '', title = '', intro = '' }) => {
    if (!title && !intro) {
        return null;
    }

    return (
        <div className={styles['ManualChapterTitle']}>
            {!!title && (
                <h1 className={styles['ManualChapterTitle__Heading']}>
                    {!!icon && (
                        <span className={styles['ManualChapterTitle__Icon']}>
                            <Icon
                                type={icon}
                                modifiers={['ManualChapterTitle']}
                            />
                        </span>
                    )}
                    {/* The heading is a flex box, which would drop the
                        spaces between glossary spans. */}
                    <span>
                        <GlossaryText text={title} />
                    </span>
                </h1>
            )}
            {!!intro && (
                <div className={styles['ManualChapterTitle__Intro']}>
                    <RawHtml html={intro} />
                </div>
            )}
        </div>
    );
};

ManualChapterTitle.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    intro: PropTypes.string,
};

export default ManualChapterTitle;
